import { API_BASE_URL, API_ENDPOINTS } from '../config/api'
import { setLastCasinoDetail } from '../utils/lastCasinoDetail'
const API_URL = API_BASE_URL;

const checkResponse = async (response) => {
  if (response.status === 401) {
    localStorage.clear();
    window.location.href = import.meta.env.BASE_URL;
    throw new Error('Unauthorized');
  }
  if (!response.ok) {
    try {
        const errorData = await response.json();
        const errorMessage = errorData.error || errorData.message || 'Network response was not ok';
        throw new Error(errorMessage);
    } catch (e) {
        // If JSON parse fails or other error, fallback to status text or default
        throw new Error(response.statusText || 'Network response was not ok');
    }
  }
  return response;
};

// Round (mid) each game page last saw in its feed poll, so My Bets can show only
// that round's bets (tenexch a9daf297): a bet stays "open" until the settlement
// worker closes it, so the old round lingered after the feed moved on.
// Super Over / Cricket V3 (bets on the match, not the ball) and array feeds
// (worli) are not filtered.
const currentRound = new Map(); // game type (lower) → mid string
const UNFILTERED_ROUND_GAMES = /^(superover|cricketv3)/;
function rememberRound(type, res) {
  const game = String(type || '').toLowerCase();
  if (!game || UNFILTERED_ROUND_GAMES.test(game)) return;
  const d = res?.data?.data ?? res?.data;
  const mid = d && !Array.isArray(d) && d.mid != null ? String(d.mid) : '';
  if (mid && mid !== '0') currentRound.set(game, mid);
  else currentRound.delete(game);
}

export const getCasinoGameDetails = async (type, signal = null) => {
  try {
    const response = await fetch(`${API_URL}/casino/casino/all-data`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        type: type,        
        data: {}           
      }),
      signal
    });

    await checkResponse(response);

    const data = await response.json();
    rememberRound(type, data);
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching casino game details:', error);
    throw error;
  }
};

export const Getlivestream = async (gmid, signal = null) => {    
    try {
        const response = await fetch(`${API_URL}/user/cricket/live-stream`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ gmid }),
        signal
        });
        await checkResponse(response);
        const data = await response.json();
        return data;
    } catch (error) {
        if (error.name === 'AbortError') {
            console.log('Request cancelled:', error.message);
            return null;
        }
        console.error('Error fetching livestream:', error);
        throw error;
    }
}

export const placeCasinoBet = async (betData, signal = null) => {
  try {
    const response = await fetch(`${API_URL}/casino/casino/placebet`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(betData),
      signal
    });

    await checkResponse(response);
    const data = await response.json();
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error placing casino bet:', error);
    throw error;
  }
};

const adminToken = () =>
  localStorage.getItem('token') || localStorage.getItem('staffToken') || localStorage.getItem('ownerToken');

/**
 * Admin game pages: DOWNLINE ka exposure (book) is round ke liye — har selection
 * ka sum. Pehle ye /user/exposures/get-exposure par logged-in admin ki apni id
 * bhejta tha, jiski koi bet nahi hoti, isliye exposure kabhi nahi dikhta tha.
 * userId sirf purane call-sites ke signature ke liye rakha hai (use nahi hota).
 * Returns { success, data: [{ team_name, exposure_amount, game_type }] }.
 */
// eslint-disable-next-line no-unused-vars
export const getMatchExposure = async (userId, matchId, signal = null) => {
  try {
    const token = adminToken();
    const response = await fetch(
      `${API_URL}/d99/net-exposure/casino/round?matchId=${encodeURIComponent(matchId)}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        signal
      }
    );

    await checkResponse(response);
    const data = await response.json();
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching match exposure:', error);
    throw error;
  }
};

/**
 * Admin game pages jo "my bets" se hi bet list + exposure banate hain (lucky7,
 * card32, teen6, ...): is round ki DOWNLINE open bets. Har bet ka `exposer` us
 * selection ka downline book (sum) hai, taaki page ka exposure map sahi aaye.
 * Returns { success, bets: [] } — purane /casino/casino/mybets jaisa shape.
 */
// eslint-disable-next-line no-unused-vars
export const getMyBets = async (userId, matchId, signal = null) => {
  try {
    const token = adminToken();
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    const [betsRes, expRes] = await Promise.all([
      fetch(`${API_URL}/d99/bet-list/casino/open-downline?roundId=${encodeURIComponent(matchId)}`, { method: 'GET', headers, signal }),
      fetch(`${API_URL}/d99/net-exposure/casino/round?matchId=${encodeURIComponent(matchId)}`, { method: 'GET', headers, signal }),
    ]);
    await checkResponse(betsRes);
    const betsJson = await betsRes.json();
    let expRows = [];
    if (expRes.ok) {
      const expJson = await expRes.json();
      expRows = Array.isArray(expJson?.data) ? expJson.data : [];
    }
    const book = {};
    expRows.forEach((r) => {
      const key = String(r.team_name || '').trim().toLowerCase();
      if (key) book[key] = (book[key] || 0) + (parseFloat(r.exposure_amount) || 0);
    });

    const bets = (Array.isArray(betsJson?.data) ? betsJson.data : []).map((b) => {
      const selection = b.selection || b.player_name || '';
      const key = String(selection).trim().toLowerCase();
      return {
        ...b,
        userName: b.username,
        selection,
        player_name: b.player_name || selection,
        stake: b.amount,
        type: String(b.game_type || '').toLowerCase() === 'lay' ? 'lay' : 'back',
        exposer: book[key] ?? 0,
        placeDate: b.created_at,
      };
    });
    return { success: !!betsJson?.success, bets };
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching my bets:', error);
    throw error;
  }
};

/**
 * Casino open/downline bets – same API as lord-admin My Bets.
 * GET .../bet-list/casino/open-downline?gameName={gameName}
 * Poll every 5s on game pages. Returns { success, data: [] }.
 */
export const getCasinoOpenBets = async (gameName, signal = null, { allRounds = false } = {}) => {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('staffToken') || localStorage.getItem('ownerToken');
    const url = `${API_URL}/d99/bet-list/casino/open-downline${gameName ? `?gameName=${encodeURIComponent(gameName)}` : ''}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      signal
    });

    await checkResponse(response);
    const data = await response.json();
    // Only the round on screen (rows without round_id are kept, never hidden).
    const mid = !allRounds && gameName ? currentRound.get(String(gameName).toLowerCase()) : null;
    if (mid && Array.isArray(data?.data)) {
      data.data = data.data.filter((b) => b.round_id == null || String(b.round_id) === mid);
    }
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching casino open bets:', error);
    throw error;
  }
};

export const getLastResults = async (type, signal = null) => {
  try {
    const response = await fetch(`${API_URL}/casino/casino/last-results`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type }),
      signal
    });

    await checkResponse(response);
    const data = await response.json();
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching last results:', error);
    throw error;
  }
};

// Casino Result Report: one day's rounds from the server's casino_result_archive
// (existing endpoint, same one the user site's result page uses). Rows: { mid, win, winName, round_date, round_time }.
export const getCasinoResultReport = async (type, date, signal = null) => {
  const response = await fetch(`${API_URL}/casino/casino/result-report`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ type, date }),
    signal
  });
  await checkResponse(response);
  return response.json();
};

export const getDetailResults = async (type, mid, signal = null) => {
  // fail ho to modal pichhle round ka result na dikhaye
  setLastCasinoDetail(type, mid, null);
  try {
    const response = await fetch(`${API_URL}/casino/casino/detail-results`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ type, mid }),
      signal
    });

    await checkResponse(response);
    const data = await response.json();
    // ResultModalLayout isi se user-site result layout banata hai (utils/lastCasinoDetail.js)
    setLastCasinoDetail(type, mid, data);
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching detail results:', error);
    throw error;
  }
};

/**
 * Result modal: the logged-in admin's downline bets on one round (tenexch 16d39afb).
 * GET /admin/reports/casino/round-bets?gameName&roundId → { success, bets: [{ id, username,
 * nation, rate, amount, win, date, ip, browser, side, deleted }] }; [] on any error.
 */
export const getCasinoRoundBets = async (gameName, roundId, signal = null) => {
  try {
    const response = await fetch(
      `${API_URL}/admin/reports/casino/round-bets?gameName=${encodeURIComponent(gameName)}&roundId=${encodeURIComponent(roundId)}`,
      { method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${adminToken()}` }, signal }
    );
    if (!response.ok) return [];
    const data = await response.json();
    return data?.success && Array.isArray(data.bets) ? data.bets : [];
  } catch (error) {
    if (error.name !== 'AbortError') console.error('Error fetching round bets:', error);
    return [];
  }
};

export const getUserExposure = async (userId, signal = null) => {
  try {
    const response = await fetch(`${API_URL}/user/bets/exposure/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      signal
    });

    await checkResponse(response);
    const data = await response.json();
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request cancelled:', error.message);
      return null;
    }
    console.error('Error fetching user exposure:', error);
    throw error;
  }
};